import { useDispatch, useSelector } from "react-redux";
import {
  addProject,
  updateProject,
  deleteProject,
  selectProject,
} from "../redux/slices/projectsSlice";

export const useProjects = () => {
  const dispatch = useDispatch();
  const { projects, selectedProjectId } = useSelector(
    (state) => state.projects
  );

  const selectedProject = projects.find((p) => p.id === selectedProjectId) || null;

  const createProject = (project) => {
    dispatch(addProject(project));
  };

  const editProject = (id, updates) => {
    dispatch(updateProject({ id, updates }));
  };

  const removeProject = (id) => {
    dispatch(deleteProject(id));
  };

  const setSelectedProject = (id) => {
    dispatch(selectProject(id));
  };

  return {
    projects,
    selectedProjectId,
    selectedProject,
    createProject,
    editProject,
    removeProject,
    setSelectedProject,
  };
};
